<template>
  <div class="filter-category-302 w-100">
    <div class="row">

      <span @click="toggleCategory('')" v-if="activeLatestFilter"
            :class="{'filter-category-302-item-active':('' == activeCategory)}"
            class="mx-1 filter-category-302-item" v-t="`category.filter.first_item`"></span>

      <m-category-wrapper @categories="findFirstCategory">
        <template v-slot="{categories}">

          <span v-for="category in categories"
                @click="toggleCategory(category)"
                :class="{'filter-category-302-item-active':(category.id == activeCategory)}"
                class="mx-1 filter-category-302-item">{{
              category.name
            }}</span>
        </template>
      </m-category-wrapper>
    </div>
  </div>
</template>

<script>
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";
import {categoryPanelProps} from "./CategoryPanelProps";

export default {
  name: "FilterCategory302",
  components: {mCategoryWrapper},
  data() {
    return {
      activeCategory: null,
    }
  },
  props: {
    ...categoryPanelProps
  },
  methods: {
    toggleCategory(category) {
      if (category == '') {
        this.activeCategory = category
        this.$emit('category', null)
      } else {
        this.activeCategory = category.id
        if (this.category_column == 'slug') {
          this.$emit('category', [category.slug])
        } else {
          this.$emit('category', [category.id])
        }
      }
    },
    findFirstCategory(categories) {
      let check = true;
      categories = categories.data.data
      categories.forEach(item => {

        if (item.products_count > 0 && check) {
          check = false
          this.$store.commit('Product/setFilters', {key: 'category', value: [item.id]})
          this.selectedCategory = [item.id]
          if (this.category_column == 'slug') {
            this.$emit('category', [item.slug])
          } else {
            this.$emit('category', [item.id])
          }


        }

      })

    },
  }

}
</script>

<style scoped>
.filter-category-302-item {
  cursor: pointer;
}
</style>